import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrCustomerDownloadLinkComponent } from './kn-br-customer-download-link.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrCustomerDownloadLinkComponent: {
                    component: KnBrCustomerDownloadLinkComponent,
                },
            },
        } as CmsConfig),
        KnBrCustomerDownloadLinkComponent,
    ],
})
export class KnBrCustomerDownloadLinkModule {}
